"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImApiTranslator = void 0;
const im_translator_1 = require("./im-translator");
class ImApiTranslator extends im_translator_1.ImTranslator {
    constructor(resourceLoader, locale, fallbackLocale) {
        super(locale, !!resourceLoader.showLogs);
        this.resourceLoader = resourceLoader;
        this.fallbackLocale = fallbackLocale;
    }
    fetchResource(resource) {
        let url = `${this.resourceLoader.url}/${resource}` + (this.fallbackLocale ? `?fallbackLocale=${this.fallbackLocale}` : '');
        if (resource === '*') {
            url = `${url}${url.includes('?') ? '&' : '?'}flattenResponse=false`;
        }
        const fetchOptions = {
            method: 'GET',
            headers: Object.assign({ 'IM-SenderID': this.resourceLoader.appName, 'IM-AcceptLanguage': this.locale, 'Accept-Language': this.locale }, this.resourceLoader.headers)
        };
        if (!!this.resourceLoader.isEditingEnabled) {
            fetchOptions.cache = "no-store";
        }
        return fetch(url, fetchOptions);
    }
    loadTranslations(resource) {
        let loader = this.loaders[resource];
        if (!loader) {
            loader = this.loaders[resource] =
                new Promise((resolve, reject) => {
                    this.fetchResource(resource)
                        .then((response) => {
                        if (response.ok) {
                            return response.json();
                        }
                        this.translations[resource] = {};
                        console.error(`Failed to load '${resource}' resource for '${this.locale}' locale. Response status - ${response.status}`);
                        reject();
                    })
                        .then((data) => {
                        if (resource === '*') {
                            for (const res in data) {
                                if (!this.loaders[res]) {
                                    this.translations[res] = data[res];
                                }
                            }
                        }
                        else {
                            this.translations[resource] = data;
                        }
                        resolve();
                    })
                        .catch(err => {
                        this.translations[resource] = {};
                        console.error(`Failed to load '${resource}' resource for '${this.locale}' locale. Check if service is available.`);
                        reject();
                    });
                });
        }
        return loader;
    }
    translate(key, interpolateParams, returnKeyIfNotFound = true) {
        const resource = this._getResourceName(key);
        return this._translate(resource, key, interpolateParams, returnKeyIfNotFound);
    }
    translateInstant(key, interpolateParams, returnKeyIfNotFound = true) {
        const resource = this._getResourceName(key);
        return this._translateInstant(resource, key, interpolateParams, returnKeyIfNotFound);
    }
    _getResourceName(key) {
        let _resource = 'Common';
        if (typeof key === 'string') {
            if (key.includes('.')) {
                _resource = key.split('.')[0];
            }
        }
        else {
            if (key[0].includes('.')) {
                _resource = key[0].split('.')[0];
            }
        }
        return _resource;
    }
}
exports.ImApiTranslator = ImApiTranslator;
